// @ts-nocheck
import { ReactComponent as Icon } from '../../assets/icons/inviteesListIcon.svg';

export default function () {
  return <Icon className="MuiSvgIcon-root" alt="Invitees" aria-label="Invitees" />;
}
